export default "__VITE_ASSET__DelW$nr7__"